import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Hotjar from "@hotjar/browser";
import { AppState } from "../../../store/app-state";

const TrackHotjar: React.FC = () => {
  const { user } = useSelector((state: AppState) => state.authState);
  const [runHotjar, setHotjar] = useState(true);

  useEffect(() => {
    if (user?.id !== undefined && runHotjar) {
      Hotjar.init(3761148, 6);
      Hotjar.identify(user?.id, {
        corporate_name: user?.corporate?.name,
        company_position: user?.company_position,
      });
      setHotjar(false);
    }
  }, [user, runHotjar]);

  return <div />;
};

export default TrackHotjar;
